import * as React from 'react';
import {Platform} from 'react-native';
import {useSelector} from 'react-redux';
import {useNavigation, useNavigationState} from '@react-navigation/native';
import {canReissueCardSelector} from '../../../../../redux/selectors/cardReissue';
import {useIsDesktop} from '../../../../hooks/useIsDesktop';
import {useStyles} from '../../../../hooks/styles';
import {useTheme} from '../../../../theme';
import {getFocusedRouteName, SCREENS_WITH_REISSUE_INFO, SCREENS_WITH_REISSUE_INFO_MOBILE} from './helpers';
import CardBlockedMessageDesktop from './desktop';
import CardBlockedMessageMobile from './mobile';

export const CardBlockedMessage = ({routeName}: {routeName?: string}) => {
  const theme = useTheme();
  const isDesktop = useIsDesktop();
  const navigation = useNavigation();
  const focusedRouteName = useNavigationState(getFocusedRouteName);
  const currentRouteName = routeName ?? focusedRouteName;
  const canReissueCard = useSelector(canReissueCardSelector());
  const showReissueHintBelow =
    !!currentRouteName &&
    (isDesktop ? SCREENS_WITH_REISSUE_INFO : SCREENS_WITH_REISSUE_INFO_MOBILE).has(currentRouteName);

  const styles = useStyles(({align}) => ({
    messageRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      marginLeft: 10,
    },
    messageStack: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      marginLeft: 16,
      flexShrink: 1,
    },
    message: {
      ...theme.fonts.bodySmallLight,
      color: theme.color.textColor,
      marginTop: Platform.OS !== 'android' ? align(3) : 0,
    },
    messageWithIconGap: {
      marginLeft: 10,
    },
    link: {
      ...theme.fonts.bodySmallLight,
      color: theme.color.primaryColor,
      marginTop: Platform.OS !== 'android' ? align(3) : 0,
    },
  }));

  const View = isDesktop ? CardBlockedMessageDesktop : CardBlockedMessageMobile;

  return (
    <View
      canReissueCard={canReissueCard}
      showReissueHintBelow={showReissueHintBelow}
      navigate={navigation.navigate as any}
      styles={styles}
    />
  );
};
